import api from "../axios_service";

export async function getCaixaAfSaldosPeriodo(id, filtros) {
  const response = await api.get(
    `/relatorios/caixa-af-saldos-periodo${id}${filtros ? filtros : ""}`
  );
  return response.data;
}
